<template>
  <div class="w-full">
    <SparkMultiFilter
      name="combo-category-filter"
      :label="label"
      :placeholder="`Select ${label.toLowerCase()}`"
      :options="categoryOptions"
      v-model="selectedCategoryValues"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapMutations } from 'vuex';
import SparkMultiFilter from '@/components/SparkComponents/SparkMultiFilter.vue';

export default {
  name: 'ComboCategoryFilter',

  components: {
    SparkMultiFilter,
  },

  props: {
    reset: { type: Number, required: true },
    label: { type: String, required: true },
    component: { type: String, required: true },
    parent: { type: String, required: true },
  },

  emits: ['selected'],

  data() {
    return {
      selectedCategoryValues: [],
      categoryOptions: [],
    };
  },

  computed: {
    ...mapState(['user', 'partLibraryFilters', 'organization']),

    comboCategories() {
      return this.organization.combo_categories;
    },
  },

  watch: {
    selectedCategoryValues: {
      handler(newVal) {
        // Use a debounced function to prevent overwhelming the backend with requests
        this.debouncedOnSelectedCategoriesChange(newVal);
      },
      deep: true,
    },

    reset: {
      handler() {
        if (this.reset) {
          this.remove();
        }
      },
    },
  },

  mounted() {
    this.getAllItems();
    if (this.parent === 'library') {
      const filter = JSON.parse(sessionStorage.getItem('libraryFilter'));
      const categories = filter?.combo_categories;
      if (categories && Object.keys(categories).length) {
        const selected = categories[this.getCategoryUid(this.label)];
        if (selected != undefined) {
          this.selectedCategoryValues = selected;
        }
      }
    }
    // Debounced function to handle the selectedCategories change event
    this.debouncedOnSelectedCategoriesChange = _.debounce(this.onSelectedCategoriesChange, 300);
  },

  methods: {
    ...mapMutations(['disablePartLibraryFilter', 'resetFilter']),

    remove() {
      this.disablePartLibraryFilter({
        [this.label]: this.component,
      });
      this.clear();
    },

    clear() {
      this.selectedCategoryValues = [];
      this.resetFilter({
        combo_categories: this.getCategoryUid(this.label),
      });
    },

    getAllItems() {
      Object.values(this.comboCategories).forEach(cat => {
        if (cat.label === this.label) {
          // Convert items to options format for SparkMultiFilter
          const itemOptions = Object.entries(cat.items).map(([uid, label]) => ({
            value: uid,
            label: label,
          }));
          
          // Add "No Category" option
          itemOptions.push({
            value: 'no-category',
            label: 'No Category',
          });
          
          // Sort options a-z by label
          this.categoryOptions = itemOptions.sort((a, b) => a.label.localeCompare(b.label));
        }
      });
    },

    getCategoryUid(categoryName) {
      let categoryUid = '';
      Object.keys(this.comboCategories).forEach(uid => {
        if (this.comboCategories[uid].label === categoryName) {
          categoryUid = uid;
        }
      });
      return categoryUid;
    },

    // method to handle the selectedCategories change event
    onSelectedCategoriesChange(newVal) {
      let uid = this.getCategoryUid(this.label);
      this.$emit('selected', {
        combo_categories: { [uid]: newVal },
      });
      if (newVal.length === 0) {
        this.resetFilter({
          combo_categories: this.getCategoryUid(this.label),
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
